import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { MaskedLine, Label } from "./Reveal";

export const PageHero = ({ kicker, title, subtitle, image, dim = false, contain = false }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "25%"]);

  return (
    <section ref={ref} className="relative flex min-h-[62vh] items-end overflow-hidden pt-20" data-testid="page-hero">
      <motion.div className="absolute inset-0" style={{ y }}>
        <img src={image} alt={title} className={`h-[120%] w-full ${contain ? "scale-[0.8] object-contain lg:translate-x-[10%]" : "object-cover"}`} loading="eager" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-[#0A0A0A]/30" />
        {dim && <div className="absolute inset-0 bg-[#0A0A0A]/55" />}
      </motion.div>
      <div className="relative mx-auto w-full max-w-7xl px-5 pb-16 pt-32 md:px-10 md:pb-24">
        {kicker && (
          <span className="block overflow-hidden">
            <motion.span
              className="block"
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.9, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            >
              <Label>{kicker}</Label>
            </motion.span>
          </span>
        )}
        <h1 className="mt-6 max-w-4xl font-serif text-4xl font-light leading-[1.02] text-[#F4F4F0] sm:text-5xl lg:text-6xl" data-testid="page-h1">
          <MaskedLine delay={0.3}>{title}</MaskedLine>
        </h1>
        {subtitle && (
          <span className="block overflow-hidden">
            <motion.p
              className="mt-6 max-w-2xl text-base leading-relaxed text-[#F4F4F0]/70 md:text-lg"
              initial={{ y: "110%" }}
              animate={{ y: 0 }}
              transition={{ duration: 0.9, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
            >
              {subtitle}
            </motion.p>
          </span>
        )}
      </div>
    </section>
  );
};
